<template>
  <div class="auto-style">
    <div class="auto-container">
      <div class="auto-header">
        <p>Auto Reply</p>
        <toggle-button :value="enabled" @change="handleAutoReplyToggle"   color="#008629" />
      </div>
      <div class="auto-content">
        <span class="description"
          >When enabled, if you receive a text message without keywords, Auto Reply will send a one-time request to respond with keywords.</span
        >
        <div class="auto-textarea">
          <textarea v-model="autoReplyText"></textarea>
          <div v-if="!isEdit" class="auto-textarea-placeholder">
            Please reply with one of the following keywords, so we can connect you to the right agent: Support, Sales,
            Quality
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';

export default {
  name: 'AutoReplyModal',
  components: { ToggleButton },
  props: {
    input: {
      type: String,
      required: true
    },
    enabled: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isEdit: false,
      autoReplyText: this.input
    };
  },
  watch: {
    autoReplyText(newValue) {
      this.isEdit = !!newValue.length;
      return this.$emit('handle-auto-reply-input', newValue);
    }
  },
  mounted() {
    this.isEdit = !!this.autoReplyText.length;
  },
  methods: {
    /**
     * Handle Auto Reply toggle
     * @param event {object} - event object
     * @returns {this}
     */
    handleAutoReplyToggle(event = {}) {
      return this.$emit('switch-auto-reply', event.value);
    }
  }
};
</script>

<style scoped lang="scss">
.auto-style {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  .auto-container {
    position: absolute;
    background-color: #ffffff;
    border: 1px solid #e8eaed;
    box-sizing: border-box;
    box-shadow: 0px 4px 10px rgba(13, 29, 63, 0.1);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    width: 580px;
 
    margin-bottom: 20px;
    .auto-header {
      height: 54px;
      background-color: #f4f5f7;
      display: flex;
      flex-direction: row;
      flex: none;
      align-items: center;
      justify-content: space-between;
      padding: 15px 26px;
      font-size: 18px;
      line-height: 20px;
      font-weight: 600;
      letter-spacing: -0.02em;
      color: #374561;
      border-radius: 10px 10px 0 0;
    }
    .auto-content {
      flex: 1;
      padding: 15px 26px;
      .description {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.01em;
        color: $colorText;
      }
      .text-word {
        width: 487px;
        height: 106px;
        left: 465px;
        top: 403px;
        background: #f4f5f7;
        margin-bottom: 10px;
      }
      .auto-textarea {
        margin-top: 15px;
        height: 80px;
        position: relative;
        background-color: #f4f5f7;
        z-index: 0;
        textarea {
          resize: none;
          height: 80px;
          width: 528px;
          border: none;
          font-size: 14px;
          font-weight: normal;
          padding: 10px 15px;
          background-color: transparent;
        }
        .auto-textarea-placeholder {
          position: absolute;
          z-index: -1;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          padding: 10px 15px;
          color: #abb3c0;
        }
      }
    }
    .auto-footer {
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-size: 10px;
      color: #98a0ad;
      padding: 0 26px;
    }
  }
}
</style>
